import { Chip, MenuItem, Select, Grid, IconButton, TextField, Grow, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react";
import { FilterOperator } from "../stores/models";
import { StoreContext } from "../StoreContext";
import { useTranslation } from "react-i18next";
import { Add, Cancel, Done } from "@mui/icons-material";
import styled from "@emotion/styled";
const StyledMenuItem = styled(MenuItem)(() => ({
    "&::before": {
        display: "none",
    },
}));
const StyledTextField = styled(TextField)(() => ({
    "& > div": {
        height: "3rem",
    },
}));
const ALL_COLUMNS = "all";
const FilterEditor = (props) => {
    const [options, setOptions] = useState([]);
    const [selectOpen, setSelectOpen] = useState(!props.filter);
    const [colValue, setColValue] = useState("");
    const [operator, setOperator] = useState(props.filter ? props.filter.op : FilterOperator.contains);
    const [filterValue, setFilterValue] = useState("");
    const [t, i18n] = useTranslation();
    useEffect(() => {
        let options = props.options.slice();
        options.splice(0, 0, { id: ALL_COLUMNS, label: t("translations:label all columns") });
        setOptions(options);
    }, [props.options]);
    useEffect(() => {
        if (props.filter) {
            if (props.filter.column) {
                setColValue(props.filter.column);
            }
            else {
                setColValue(ALL_COLUMNS);
            }
            setFilterValue(props.filter.value);
        }
    }, [props.filter]);
    const endEditing = (filter) => {
        setColValue("");
        setFilterValue("");
        props.onFinish(filter);
    };
    const isValid = () => {
        return colValue && filterValue && operator;
    };
    const cancel = () => {
        endEditing();
    };
    const commit = () => {
        if (!colValue) {
            endEditing();
        }
        if (colValue == ALL_COLUMNS) {
            endEditing({ op: FilterOperator[operator], value: filterValue });
        }
        else {
            endEditing({ op: FilterOperator[operator], value: filterValue, column: colValue });
        }
    };
    const onFilterChange = (e) => {
        setFilterValue(e.target.value);
    };
    const onOperatorChanged = (e) => {
        setOperator(e.target.value);
    };
    const onColValueChanged = (event) => {
        setColValue(event.target.value);
        if (event.target.value == ALL_COLUMNS) {
            setOperator(FilterOperator.contains);
        }
    };
    const keyPress = (event) => {
        if (event.key == "Enter") {
            commit();
        }
        if (event.key == "Escape") {
            cancel();
        }
    };
    const renderColEditor = () => {
        let operators = Object.keys(FilterOperator);
        if (colValue == ALL_COLUMNS) {
            operators.filter((op) => op == FilterOperator.contains);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Grid, { item: true },
                React.createElement(Select, { style: { minWidth: "6rem" }, label: t("translations:editor filter operator"), key: "filter-constructor_op", onChange: onOperatorChanged, value: operator }, Object.keys(FilterOperator)
                    .filter((op) => colValue != ALL_COLUMNS || op == FilterOperator.contains)
                    .map((operator) => {
                    return (React.createElement(StyledMenuItem, { key: operator, value: operator }, t("translations:filter operator " + operator)));
                }))),
            React.createElement(Grid, { item: true, style: { marginBottom: "-1px", width: "12rem", display: "flex", justifyContent: "flex-end", flexDirection: "column" } },
                React.createElement(StyledTextField, { ref: (input) => {
                        input && input.focus();
                    }, id: "filter-constructor-col", onChange: (e) => onFilterChange(e), onKeyUp: (e) => keyPress(e), autoFocus: true, placeholder: "text contains...", defaultValue: filterValue })),
            React.createElement(Grid, { item: true },
                React.createElement(IconButton, { onClick: cancel },
                    React.createElement(Cancel, null)),
                React.createElement(IconButton, { disabled: !isValid(), onClick: commit },
                    React.createElement(Done, null)))));
    };
    return (React.createElement(Grow, { in: true },
        React.createElement("div", null,
            React.createElement(Paper, { elevation: 6, style: { padding: "0.5rem" } },
                React.createElement(Grid, { container: true, direction: "row", spacing: 1, alignItems: "center" },
                    React.createElement(Grid, { item: true, style: { minWidth: "12rem" } },
                        React.createElement(Select, { style: { minWidth: "12rem" }, label: "Filter", key: "filter-constructor_tf", onChange: onColValueChanged, value: colValue, open: selectOpen, onOpen: () => setSelectOpen(true), onClose: () => setSelectOpen(false) }, options.map((option) => {
                            return (React.createElement(StyledMenuItem, { key: option.id, value: option.id }, option.label));
                        }))),
                    colValue && renderColEditor())))));
};
const ConditionWidget = (props) => {
    const [editMode, setEditMode] = useState(false);
    const context = useContext(StoreContext);
    const [t, i18n] = useTranslation();
    let filterStore = context.rootStore.filterStore;
    let dataStore = context.rootStore.dataStore;
    const handleStartEdit = () => {
        setEditMode(true);
    };
    const handleStopEdit = (filter) => {
        if (filter && filter.value) {
            let column = props.condition.column ? props.condition.column : "";
            filterStore.changeFilter(props.condition.value, column, filter);
        }
        else {
            filterStore.removeFilter(props.condition);
        }
        dataStore.loadData();
        setEditMode(false);
    };
    const getReadableFilter = () => {
        let column = props.condition.column ? props.condition.column + " " : "";
        let operator = t("translations:label filter operator " + props.condition.op);
        return column + operator + " " + props.condition.value;
    };
    if (editMode) {
        return React.createElement(FilterEditor, { options: props.options, onFinish: handleStopEdit, filter: props.condition });
    }
    else {
        return (React.createElement(React.Fragment, null,
            React.createElement(Chip, { key: props.condition.value, clickable: true, onClick: () => handleStartEdit(), label: getReadableFilter(), onDelete: props.onDelete })));
    }
};
const Adder = (props) => {
    const context = useContext(StoreContext);
    const [building, setBuilding] = useState(false);
    let filterStore = context.rootStore.filterStore;
    let dataStore = context.rootStore.dataStore;
    const commitColFilter = (filter) => {
        if (filter) {
            filterStore.createFilter(filter);
            dataStore.loadData();
        }
        setBuilding(false);
    };
    return (React.createElement(React.Fragment, null,
        building && React.createElement(FilterEditor, { onFinish: commitColFilter, options: props.options }),
        !building && (React.createElement(IconButton, { onClick: () => setBuilding(true), size: "small", disabled: props.disabled, style: { color: "inherit" } },
            React.createElement(Add, null)))));
};
const FilterWidget = observer(() => {
    const context = useContext(StoreContext);
    let columnOptions = [];
    let dataStore = context.rootStore.dataStore;
    let filterStore = context.rootStore.filterStore;
    if (dataStore.tableModel) {
        columnOptions = dataStore.tableModel.columns.map((col) => {
            return { id: col.label, label: col.label };
        });
    }
    return (React.createElement(Grid, { container: true, spacing: 1 },
        filterStore.filters.map((condition) => (React.createElement(Grid, { item: true },
            React.createElement(ConditionWidget, { options: columnOptions, condition: condition, onDelete: () => {
                    filterStore.removeFilter(condition);
                    dataStore.loadData();
                } })))),
        React.createElement(Grid, { item: true },
            React.createElement(Adder, { disabled: false, options: columnOptions }))));
});
export default FilterWidget;
